const navbarStyles = {
    navbar: "fixed top-0 left-0 right-0 z-10 flex items-center justify-between p-4 bg-gradient-to-r from-white to-transparent bg-clip-padding backdrop-blur-md",
    logoContainer: "flex items-center space-x-2 cursor-pointer",
    logoImage: "h-12 w-12",
    navLinks: "flex space-x-4 text-base font-medium",
    navLink: "hover:text-blue-500 transition duration-300 ease-in-out",
    authLinks: "flex space-x-4",
    authLink: "text-base font-medium hover:text-blue-500 transition duration-300 ease-in-out px-5",
    ctaButton: "bg-blue-500 hover:bg-blue-600 text-white py-3 px-3 mx-2 rounded-lg text-base font-medium transition duration-300 ease-in-out",
    span: "font-semibold text-2xl",
};



export default navbarStyles;
